import { AlertVariant, StatusAlert } from '@/components/atoms/StatusAlert';

export const RegenerateTranslationNudge = ({
  isVisible,
  className = ''
}: {
  isVisible: boolean;
  className?: string;
}) => {
  if (!isVisible) {
    return <></>;
  }
  return (
    <div className={className}>
      <StatusAlert
        type={AlertVariant.Info}
        subHeading="In case you've updated the original transcript, please regenerate the existing translations to reflect those changes."
      />
    </div>
  );
};
